export default {
  name: '问卷反馈',
  path: '/questionnaire',
  redirect: '/questionnaire/list',
  component: () => import('@/views/layout/index.vue'),
  children: [
    {
      name: '问卷列表',
      path: '/questionnaire/list',
      component: () => import('@/views/questionnaire/list/index.vue'),
    },
  ],
};
